import { ITag } from "@Totum/Main/Components/groups/GroupUtils";
import { TagConfig, TagType } from "@Totum/Main/Components/groups/TagProperties";
import { hasCapability } from "@Totum/Main/Utils";
import { useState } from "react";

/**
 * Presents the `RoleTag` component with the UI model and handlers.
 */
const useRoleTagPresenter = (tag: ITag) => {
    // ** Constants & Variables ** //
    const [popupVisible, setPopupVisible] = useState<boolean>(false);
    const [tagVisible, setTagVisible] = useState<boolean>(true);
    const config = TagConfig.get(tag.type);

    // ** Hooks ** //
    // ** Handlers ** //

    /**
     * Return true if the user has the capability to remove this tag type.
     */
    const allowDelete = () => {
        if (!("enableDelete" in tag) || !config) return false;
        return hasCapability(config.deleteCapability, tag.context, tag.instanceId);
    };

    /**
     * Pop confirm delete ok button selected, or triggered automatically if confirm deleted is disabled.
     */
    const confirmDelete = () => {
        setPopupVisible(false);
        removeTag();
    };

    /**
     * Popup confirm delete cancel button selected.
     */
    const cancelDelete = () => {
        setPopupVisible(false);
    };

    const removeTag = () => {
        if (!("context" in tag)) return;
        setTagVisible(false);
        if (tag.type === TagType.Role) {
            tag.deleteAction.apply(null, [{ parentGroupId: "", name: "", count: 0 }]);
        }
    };

    /**
     * Manage the tag removal popup visibility.
     * @param visible
     */
    const handleVisibleChange = (visible: boolean) => {
        if (!visible) {
            setPopupVisible(visible);
            return;
        }

        if (!config?.deleteConfirm) {
            confirmDelete();
        } else {
            setPopupVisible(visible);
        }
    };

    // ** Exports ** //

    return {
        handlers: {
            handleVisibleChange,
            cancelDelete,
            confirmDelete,
        },
        uiModel: {
            allowDelete,
            popupVisible,
            tagVisible,
            config,
        },
    };
};

export default useRoleTagPresenter;
